import React, { useEffect, useCallback } from 'react';

// Round 39 — the sidebar speaks the workflow-tile color language: each item
// gets a small tone-tinted icon chip (same tone family as MenuCard tiles),
// labels stay brand navy. Tones come from LayoutMenuData's `tone` field.
const MENU_TONES = {
    violet: ["rgba(91,80,214,0.14)",  "#5b50d6"],
    teal:   ["rgba(13,148,136,0.14)", "#0d9488"],
    green:  ["rgba(10,179,156,0.14)", "#0ab39c"],
    orange: ["rgba(234,124,28,0.14)", "#ea7c1c"],
    blue:   ["rgba(41,156,219,0.14)", "#299cdb"],
    indigo: ["rgba(67,56,202,0.14)",  "#4338ca"],
    cyan:   ["rgba(8,145,178,0.14)",  "#0891b2"],
    pink:   ["rgba(219,39,119,0.14)", "#db2777"],
    slate:  ["rgba(71,85,105,0.14)",  "#475569"],
};
const MenuIconChip = ({ icon, tone }) => {
    const [bg, fg] = MENU_TONES[tone] || MENU_TONES.violet;
    return (
        <span className="ssw-menu-chip" style={{ background: bg, color: inkFor(fg) }}>
            <i className={icon}></i>
        </span>
    );
};
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
import { Collapse } from 'reactstrap';
import { inkFor } from "../../utils/themeColor"; // Round THEME-2

// Import Data
import navdata from "../LayoutMenuData";
//i18n
import { withTranslation } from "react-i18next";
import { useSelector, shallowEqual } from "react-redux";

const VerticalLayout = (props) => {
    const navData = navdata().props.children;

    /*
 layout settings
 */
    const {
        leftsidbarSizeType, sidebarVisibilitytype, layoutType
    } = useSelector(state => ({
        leftsidbarSizeType: state.Layout.leftsidbarSizeType,
        sidebarVisibilitytype: state.Layout.sidebarVisibilitytype,
        layoutType: state.Layout.layoutType
    }), shallowEqual);

    //vertical and semibox resize events
    const resizeSidebarMenu = useCallback(() => {
        const windowSize = document.documentElement.clientWidth;
        const hamburger = document.querySelector(".hamburger-icon");

        if (windowSize >= 1025) {
            if (document.documentElement.getAttribute("data-layout") === "vertical") {
                document.documentElement.setAttribute("data-sidebar-size", leftsidbarSizeType);
            }

            if (document.documentElement.getAttribute("data-layout") === "semibox") {
                document.documentElement.setAttribute("data-sidebar-size", leftsidbarSizeType);
            }

            if (!hamburger) return;

            if (
                sidebarVisibilitytype === "show" ||
                layoutType === "vertical" ||
                layoutType === "twocolumn"
            ) {
                hamburger.classList.remove("open");
            } else {
                hamburger.classList.add("open");
            }

        } else if (windowSize < 1025 && windowSize > 767) {
            document.body.classList.remove("twocolumn-panel");

            if (document.documentElement.getAttribute("data-layout") === "vertical") {
                document.documentElement.setAttribute("data-sidebar-size", "sm");
            }

            if (document.documentElement.getAttribute("data-layout") === "semibox") {
                document.documentElement.setAttribute("data-sidebar-size", "sm");
            }

            hamburger?.classList.add("open");

        } else if (windowSize <= 767) {
            document.body.classList.remove("vertical-sidebar-enable");

            if (document.documentElement.getAttribute("data-layout") !== "horizontal") {
                document.documentElement.setAttribute("data-sidebar-size", "lg");
            }

            hamburger?.classList.add("open");
        }
    }, [leftsidbarSizeType, sidebarVisibilitytype, layoutType]);


    useEffect(() => {
        window.addEventListener("resize", resizeSidebarMenu, true);
        return () => {
            window.removeEventListener("resize", resizeSidebarMenu, true);
        };
    }, [resizeSidebarMenu]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const initMenu = () => {
            const pathName = process.env.PUBLIC_URL + props.router.location.pathname;
            const ul = document.getElementById("navbar-nav");
            const items = ul.getElementsByTagName("a");
            let itemsArray = [...items]; // converts NodeList to Array
            removeActivation(itemsArray);
            let matchingMenuItem = itemsArray.find((x) => {
                return x.pathname === pathName;
            });
            if (matchingMenuItem) {
                activateParentDropdown(matchingMenuItem);
            }
        };
        if (props.layoutType === "vertical") {
            initMenu();
        }
    }, [props.router.location.pathname, props.layoutType]);

    function activateParentDropdown(item) {

        item.classList.add("active");
        let parentCollapseDiv = item.closest(".collapse.menu-dropdown");

        if (parentCollapseDiv) {

            // to set aria expand true remaining
            parentCollapseDiv.classList.add("show");
            parentCollapseDiv.parentElement.children[0].classList.add("active");
            parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
            if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
                parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
                if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
                    parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
                if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse")) {
                    parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").classList.add("show");
                    parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").previousElementSibling.classList.add("active");
                }
            }
            return false;
        }
        return false;
    }

    const removeActivation = (items) => {
        let actiItems = items.filter((x) => x.classList.contains("active"));

        actiItems.forEach((item) => {
            if (item.classList.contains("menu-link")) {
                if (!item.classList.contains("active")) {
                    item.setAttribute("aria-expanded", false);
                }
                if (item.nextElementSibling) {
                    item.nextElementSibling.classList.remove("show");
                }
            }
            if (item.classList.contains("nav-link")) {
                if (item.nextElementSibling) {
                    item.nextElementSibling.classList.remove("show");
                }
                item.setAttribute("aria-expanded", false);
            }
            item.classList.remove("active");
        });
    };

    return (
        <React.Fragment>
            {/* menu Items */}
            {(navData || []).map((item, key) => {
                return (
                    <React.Fragment key={key}>
                        {/* Main Header */}

                        {item['isHeader'] ?
                            <li className="menu-title"><span data-key="t-menu">{props.t(item.label)}</span></li>
                            : (
                                (item.subItems ? (
                                    <li className="nav-item">
                                        <Link
                                            onClick={item.click}
                                            className="nav-link menu-link"
                                            to={item.link ? item.link : "/#"}
                                            data-bs-toggle="collapse"
                                        >
                                            <MenuIconChip icon={item.icon} tone={item.tone} /> <span data-key="t-apps">{props.t(item.label)}</span>
                                        </Link>
                                        <Collapse
                                            className="menu-dropdown"
                                            isOpen={item.stateVariables}
                                            id="sidebarApps">
                                            <ul className="nav nav-sm flex-column test">
                                                {/* subItms  */}
                                                {item.subItems && ((item.subItems || []).map((subItem, key) => (
                                                    <React.Fragment key={key}>
                                                        {subItem.isExternal ? (
                                                            // External app inside a dropdown (e.g. Apps ▸ Tool Tracker):
                                                            // plain <a> in a new tab, like top-level external items.
                                                            <li className="nav-item">
                                                                <a
                                                                    className="nav-link ssw-submenu-link"
                                                                    href={subItem.link}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer">
                                                                    {subItem.icon && <MenuIconChip icon={subItem.icon} tone={subItem.tone} />}
                                                                    <span>{props.t(subItem.label)}</span>
                                                                    <i className="ri-external-link-line ms-1 text-muted" style={{ fontSize: 12 }}></i>
                                                                </a>
                                                            </li>
                                                        ) : !subItem.isChildItem ? (
                                                            <li className="nav-item">
                                                                <Link
                                                                    to={subItem.link ? subItem.link : "/#"}
                                                                    className={subItem.icon ? "nav-link ssw-submenu-link" : "nav-link"}
                                                                >
                                                                    {subItem.icon && <MenuIconChip icon={subItem.icon} tone={subItem.tone} />}
                                                                    {subItem.icon ? <span>{props.t(subItem.label)}</span> : props.t(subItem.label)}
                                                                    {subItem.badgeName ?
                                                                        <span className={"badge badge-pill bg-" + subItem.badgeColor} data-key="t-new">{subItem.badgeName}</span>
                                                                        : null}
                                                                </Link>
                                                            </li>
                                                        ) : (
                                                            <li className="nav-item">
                                                                <Link
                                                                    onClick={subItem.click}
                                                                    className="nav-link"
                                                                    to="/#"
                                                                    data-bs-toggle="collapse"
                                                                > {props.t(subItem.label)}
                                                                </Link>
                                                                <Collapse className="menu-dropdown" isOpen={subItem.stateVariables} id="sidebarEcommerce">
                                                                    <ul className="nav nav-sm flex-column">
                                                                        {/* child subItms  */}
                                                                        {subItem.childItems && (
                                                                            (subItem.childItems || []).map((childItem, key) => (
                                                                                <React.Fragment key={key}>
                                                                                    {!childItem.childItems ?
                                                                                        <li className="nav-item">
                                                                                            <Link
                                                                                                to={childItem.link ? childItem.link : "/#"}
                                                                                                className="nav-link">
                                                                                                {props.t(childItem.label)}
                                                                                            </Link>
                                                                                        </li>
                                                                                        : <li className="nav-item">
                                                                                            <Link to="/#" className="nav-link" onClick={childItem.click} data-bs-toggle="collapse">
                                                                                                {props.t(childItem.label)}
                                                                                            </Link>
                                                                                            <Collapse className="menu-dropdown" isOpen={childItem.stateVariables} id="sidebaremailTemplates">
                                                                                                <ul className="nav nav-sm flex-column">
                                                                                                    {childItem.childItems.map((subChildItem, key) => (
                                                                                                        <li className="nav-item" key={key}>
                                                                                                            <Link to={subChildItem.link} className="nav-link" data-key="t-basic-action">{props.t(subChildItem.label)} </Link>
                                                                                                        </li>
                                                                                                    ))}
                                                                                                </ul>
                                                                                            </Collapse>
                                                                                        </li>
                                                                                    }
                                                                                </React.Fragment>
                                                                            ))
                                                                        )}
                                                                    </ul>
                                                                </Collapse>
                                                            </li>
                                                        )}
                                                    </React.Fragment>
                                                ))
                                                )}
                                            </ul>

                                        </Collapse>
                                    </li>
                                ) : item.isExternal ? (
                                    // External app (e.g. Tool Tracker) — a SEPARATE application
                                    // hosted at its own URL, opened in a NEW browser tab. It is not
                                    // a react-router route, so render a plain <a>, not <Link>.
                                    // rel="noopener noreferrer" stops the opened tab from touching
                                    // this window and hides the referrer.
                                    <li className="nav-item">
                                        <a
                                            className="nav-link menu-link"
                                            href={item.link}
                                            target="_blank"
                                            rel="noopener noreferrer">
                                            <MenuIconChip icon={item.icon} tone={item.tone} /> <span>{props.t(item.label)}</span>
                                        </a>
                                    </li>
                                ) : (
                                    <li className="nav-item">
                                        <Link
                                            className="nav-link menu-link"
                                            to={item.link ? item.link : "/#"}>
                                            <MenuIconChip icon={item.icon} tone={item.tone} /> <span>{props.t(item.label)}</span>
                                        </Link>
                                    </li>
                                ))
                            )
                        }
                    </React.Fragment>
                );
            })}
        </React.Fragment>
    );
};

VerticalLayout.propTypes = {
    location: PropTypes.object,
    t: PropTypes.any,
};

export default withRouter(withTranslation()(VerticalLayout));
